import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Card, CardActionArea, CardContent, Chip, Typography,
} from '@mui/material';
import {
  Inventory2Rounded as StockIcon,
  ReceiptLongRounded as ExpenseIcon,
  PeopleAltRounded as DuesIcon,
  ArrowForwardRounded as ArrowIcon,
} from '@mui/icons-material';

const modules = [
  {
    title: 'Stock', label: 'Purchase', icon: <StockIcon sx={{ fontSize: 54 }} />,
    detail: 'Buy stock from suppliers and keep inventory in sync.',
    path: '/locsy/products/inventory', tone: ['#fff7d6', '#dff7d4'],
  },
  {
    title: 'Expenses', label: 'Expenses', icon: <ExpenseIcon sx={{ fontSize: 54 }} />,
    detail: 'Salary, rent, current and other business payments.',
    path: '/locsy/products/inventory', tone: ['#e9e2ff', '#e5f3ff'],
  },
  {
    title: 'Customers', label: 'Dues', icon: <DuesIcon sx={{ fontSize: 54 }} />,
    detail: 'Credit bills, collections, calls and WhatsApp follow-up.',
    path: '/customer/search', tone: ['#dff4ff', '#e9e3ff'],
  },
];

export default function AccountsHub() {
  const navigate = useNavigate();
  return (
    <Box sx={{ maxWidth: 1180, mx: 'auto', p: { xs: 2, md: 3 } }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', mb: 2 }}>
        <Box><Typography variant="h4" fontWeight={800}>Accounts</Typography><Typography color="text.secondary">Manage stock, expenses and customer dues.</Typography></Box>
        <Chip label="Vyapar" color="primary" variant="outlined" />
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(230px, 1fr))', gap: 2 }}>
        {modules.map((module) => (
          <Card key={module.title} elevation={0} sx={{ borderRadius: 3, border: '1px solid', borderColor: 'divider', overflow: 'hidden' }}>
            <CardActionArea onClick={() => navigate(module.path)} sx={{ height: '100%', alignItems: 'stretch' }}>
              <Box sx={{ height: 155, display: 'grid', placeItems: 'center', color: '#305b68', background: `radial-gradient(circle at 50% 35%, #fff 0 22%, transparent 23%), linear-gradient(135deg, ${module.tone[0]}, ${module.tone[1]})` }}>{module.icon}</Box>
              <CardContent sx={{ minHeight: 145 }}>
                <Typography fontWeight={800}>{module.label}</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.75 }}>{module.detail}</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 1.5, color: 'primary.main', fontSize: 14, fontWeight: 700 }}>Open <ArrowIcon fontSize="small" /></Box>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Box>
    </Box>
  );
}
